export const SUPPORTED_LOCALES = ["en", "sv", "de"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "en";

export function isLocale(v: unknown): v is Locale {
  return typeof v === "string" && (SUPPORTED_LOCALES as readonly string[]).includes(v);
}

export function localeFromTag(tag: string | undefined): Locale | null {
  if (!tag) return null;
  const base = tag.toLowerCase().split("-")[0];
  return isLocale(base) ? base : null;
}

export function detectBrowserLocale(): Locale {
  const browserNavigator = (globalThis as typeof globalThis & { navigator?: { language?: string; languages?: readonly string[] } }).navigator;
  if (!browserNavigator) return DEFAULT_LOCALE;
  const candidates = [browserNavigator.language, ...(browserNavigator.languages ?? [])];
  for (const c of candidates) {
    const hit = localeFromTag(c);
    if (hit) return hit;
  }
  return DEFAULT_LOCALE;
}

export const LOCALE_LABEL: Record<Locale, string> = {
  en: "English",
  sv: "Svenska",
  de: "Deutsch",
};
